import _ from 'lodash';
import { apiSearch, apiFetch } from '../modules/utility';

const apiBase = 'timeClockPermission';
const idField = `${apiBase}Id`;
const idsField = `${idField}s`;

const MY_TIME_CLOCK_PERMISSIONS = 'myTimeClockPermissions/SEARCH';

const initialState = {
	myTimeClockPermissionIds: undefined,
	myCanViewUserIds: undefined,
	myCanModifyUserIds: undefined,
	byStatus: {},
};

const reducers = (state = initialState, action) => {
	if (action.type === MY_TIME_CLOCK_PERMISSIONS) {
		return {
			...state,
			myTimeClockPermissionIds: _.map(action.timeClockPermissions, 'timeClockPermissionId'),
			myCanViewUserIds: action.canViewUserIds,
			myCanModifyUserIds: action.canModifyUserIds,
		};
	} else {
		return state;
	}
};
export default reducers;

export const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			forceEmptySet: true,
			callback,
		});
	};
};

export const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate: idsField,
			params,
			dispatch,
			callback,
		});
	};
};

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const getMine = (p = {}) => {
	const { callback = _.noop } = p;

	return (dispatch) => {
		const params = {};

		apiFetch({
			method: `${apiBase}.getMyTimeClockPermissions`,
			params,
			dispatch,
			callback: (err, r) => {
				if (err) {
					return callback(err);
				}

				const timeClockPermissions = _.get(r, ['collections', 'timeClockPermissionCollection']);
				const canViewUserIds = _.get(r, 'canViewUserIds', []);
				const canModifyUserIds = _.get(r, 'canModifyUserIds', []);

				dispatch({
					type: MY_TIME_CLOCK_PERMISSIONS,
					timeClockPermissions,
					canViewUserIds,
					canModifyUserIds,
				});
				callback();
			},
		});
	};
};
